const channel = {
  //美丽天使
  path: 'channel', //办公室
  component: () => import("@/views/member/channel/channel"),
  meta: {
    tabBar: 'home'
  },
  children:[
    // {
    //   // 收益提现
    //   path: 'earnings',
    //   component: () => import("@/views/member/channel/earnings"),
    // },
  ]
};

export default channel;
